import { render } from "./FranchiseMapComponent.vue?vue&type=template&id=2785115b"
import script from "./FranchiseMapComponent.vue?vue&type=script&lang=js"
export * from "./FranchiseMapComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__